export default __webpack_public_path__ + "static/media/image1.34fc0a97.jpg";